<div *ngIf="active">
    <div class="panel-title">
        <div class="title">
            <span>Nearby</span>
            <span class="icon-ui-close" style="cursor: pointer;" (click)="active=false"></span>
        </div>
        <div class="distance">
            <!--<label for="distance">Within:&nbsp;</label>-->
            <input id="distance" type="number" name="distance" [(ngModel)]="distance" (ngModelChange)="onDistanceChange($event)" min="0" [max]="distanceMax">
            <select id="unit" name="unit" class="modifier-class" [(ngModel)]="distanceUnit">
                <option *ngFor="let unit of distanceUnits" [value]="unit.value">{{ unit.name }}</option>
            </select>
            <button id="refreshBuffer" class="btn btn-small icon-ui-refresh" (click)="bufferChanged()"></button>
        </div>
    </div>
    <div *ngIf="!loading" class="panel-container">
        <div class="panel-header">
            <div class="node-title">
                <button (click)="navigateBack(currentNode.parent)"
                    class="btn btn-small icon-ui-left-triangle-arrow"></button>
                <span class="node-info-name">{{ currentNode?.data?.title || currentNode?.data?.name }}</span>
            </div>
            <div class="order" *ngIf="orderBy && groups">
                <label for="orderBy">Group By:</label>
                <select id="orderBy" class="modifier-class" [ngModel]="orderBy" (ngModelChange)="orderByChange($event)">
                    <option *ngFor="let column of nearbyService.getSortableColumns(currentNode)" [value]="column.name">
                        {{ column.alias || column.name }}</option>
                </select>
                <div (click)="changeOrder()">
                    <svg *ngIf="asc" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"
                        class="svg-icon">
                        <path
                            d="M12 13h6v2h-6v-2zm0 6h10v-2H12v2zm0 4h14v-2H12v2zm0 2v2h18v-2H12zm0-19L7 1 2 6v2.8l4-4V31h2V4.8l4 4V6z" />
                    </svg>
                    <svg *ngIf="!asc" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"
                        class="svg-icon">
                        <path
                            d="M12 17h6v2h-6v-2zm0-2h10v-2H12v2zm0-4h14V9H12v2zm0-6v2h18V5H12zM8 17.5V1H6V27.2l-4-4V26l5 5 5-5v-2.8l-4 4v-9.7z" />
                    </svg>
                </div>
            </div>
            <div>
                <div class="filter">
                    <input type="text" placeholder="Filter by ..." class="input-search input-minimal"
                        [(ngModel)]="searchText" autofocus>
                    <button class="btn btn-small btn-clear icon-ui-close-circled" (click)="clearFilter()"></button>
                </div>
                <div class="side"
                    *ngIf="currentNode?.children.length > 0 && currentNode?.data.columnList?.includes('SIDE_IND')">
                    <label class="toogle-switch modifier-class">
                        <input type="checkbox" class="toggle-switch-input" [(ngModel)]="showPrimary">
                        <span class="toggle-switch-track margin-right-1"></span>
                        <span class="toggle-switch-label font-size--1">Primary</span>
                    </label>
                    <label class="toogle-switch modifier-class">
                        <input type="checkbox" class="toggle-switch-input" [(ngModel)]="showSecondary">
                        <span class="toggle-switch-track margin-right-1"></span>
                        <span class="toggle-switch-label font-size--1">Secondary</span>
                    </label>
                </div>
            </div>
        </div>
        <div class="tree-container">
            <div class="tree-node"
                *ngFor="let child of currentNode?.children | mcNearbyFilterBy:searchText:showPrimary:showSecondary"
                [hidden]="groups">
                <div class="node-content" *ngIf="child.data.nodeType !== NodeType.Document"
                    (mouseenter)="onMouseEnter(child)" (mouseleave)="onMouseLeave()">
                    <button class="node-button" (click)="navigateToNode(child,assets)"
                        [disabled]="!child?.data?.enabled || child?.loading" [attr.title]="child?.data?.description">
                        <span class="display-text" [innerText]="child?.name"></span><span
                            *ngIf="child?.loading">...</span>
                    </button>
                </div>
                <div class="document" *ngIf="child.data.nodeType === NodeType.Document">
                    <span class="file-name">{{ child.data.name }}</span>
                    <div class="options-container">
                        <a class="open icon-ui-maximize option" title="open in new tab" [href]="child.data.record.url"
                            target="_blank" rel="noopener noreferrer"></a>
                        <a class="download icon-ui-download option" title="download" [href]="child.data.record.url"
                            download></a>
                    </div>
                </div>
                <div *ngIf="!currentNode.children.length">
                    <span>No data found.</span>
                </div>
            </div>
            <div class="group" *ngFor="let group of groups">
                <button class="accordion" (click)="toggleAccordion($event)"
                    *ngIf="(group[1] | mcNearbyFilterBy:searchText:showPrimary:showSecondary).length > 0">
                    {{ group[0] }}
                </button>
                <div class="panel">
                    <div class="tree-node"
                        *ngFor="let child of group[1] | mcNearbyFilterBy:searchText:showPrimary:showSecondary">
                        <div class="node-content" *ngIf="child.data.nodeType !== NodeType.Document"
                            (mouseenter)="onMouseEnter(child)" (mouseleave)="onMouseLeave()">
                            <button class="node-button" (click)="navigateToNode(child,assets)"
                                [disabled]="!child?.data?.enabled || child?.loading"
                                [attr.title]="child?.data?.description">
                                <span class="display-text" [innerText]="child?.name"></span><span
                                    *ngIf="child?.loading"> ...</span>
                            </button>
                            <div #dropdown class="dropdown">
                                <button class="btn btn-transparent dropdown-btn" tabindex="0" aria-haspopup="true"
                                    aria-expanded="false" (click)="toggleDropdown($event)">
                                    <span class="icon-ui-handle-horizontal icon-ui-flush"></span>
                                </button>
                                <nav class="dropdown-content" role="menu">
                                    <div *ngIf="child?.data.link">
                                        <a href="#" title="Open Related App" [href]="child?.data.link" target="_blank"
                                            (click)="onLinkOpen()">Open App</a>
                                    </div>
                                    <div *ngIf="child.data?.graphic">
                                        <a href="#" title="Street View" (click)="onStreetViewOpen(child)">Street
                                            View</a>
                                        <a href="#" title="Video Log" (click)="onVideoLogOpen(child)">Video Log</a>
                                    </div>
                                </nav>
                            </div>
                        </div>
                        <div class="document" *ngIf="child.data.nodeType === NodeType.Document">
                            <span class="file-name">{{ child.data.name }}</span>
                            <div class="options-container">
                                <a class="open icon-ui-maximize option" title="open in new tab"
                                    [href]="child.data.record.url" target="_blank" rel="noopener noreferrer"></a>
                                <a class="download icon-ui-download option" title="download"
                                    [href]="child.data.record.url" download></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="loading">
        <div class="loader is-active padding-leader-3 padding-trailer-3">
            <div class="loader-bars"></div>
            <div class="loader-text">{{ loaderText }}</div>
        </div>
    </div>
    <div class="panel-footer">
    </div>
</div>
